<template>
    <svg xmlns="http://www.w3.org/2000/svg" :height="size" :width="size" :fill="color" viewBox="0 -960 960 960">
        <path d="m296-224-56-56 240-240 240 240-56 56-184-183-184 183Zm0-240-56-56 240-240 240 240-56 56-184-183-184 183Z"/>
    </svg>
</template>

<script>
  export default {
    name: 'IconBedTimeUp',
    props: {
       color: {
        type: String,
        default: "#F3F3F3",
       },
       size: {
        type: String,
        default: "1rem",
       },
    }
  }
</script>